export default function removeSpacesAndDashes(value = '') {
  return value.replace(/[-\s]/g, '')
}
